function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.852 7.836H2.984V12H.641V.625h4.226c1.344 0 2.38.3 3.11.898.729.6 1.093 1.446 1.093 2.54 0 .776-.169 1.424-.508 1.945-.333.515-.84.927-1.523 1.234L9.5 11.891V12H6.984L4.852 7.836zM2.984 5.937h1.891c.589 0 1.044-.148 1.367-.445.323-.302.485-.716.485-1.242 0-.536-.154-.958-.461-1.266-.302-.307-.769-.46-1.399-.46H2.984v3.413zM19.47.625v7.492c0 1.245-.39 2.23-1.172 2.953-.776.724-1.839 1.086-3.188 1.086-1.328 0-2.382-.351-3.164-1.054-.78-.704-1.18-1.67-1.195-2.899V.625h2.344v7.508c0 .745.177 1.289.531 1.633.36.338.854.507 1.484.507 1.318 0 1.987-.692 2.008-2.078V.625h2.352z",
  fill: "#fff"
});

function SvgLangRu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    fill: "none"
  }, props), _ref);
}

export default SvgLangRu;